import { HiChevronRight, HiChevronLeft } from "react-icons/hi2"

export const NextArrow = ({ className, style, onClick }) => {
  return (
    <div
      className={className}
      style={{ ...style, zIndex: 1 }}
      onClick={onClick}
    >
      <HiChevronRight color="#fff" size={50} />
    </div>
  )
}

export const PrevArrow = ({ className, style, onClick }) => {
  return (
    <div
      className={className}
      style={{ ...style, zIndex: 1 }}
      onClick={onClick}
    >
      <HiChevronLeft size={50} color="#fff" />
    </div>
  )
}
